module.exports = __webpack_public_path__ + "static/img/winter_orangePic.4e8597cd.png";